import { defaultRules } from "simple-markdown"
import type { MarkdownRule } from "../parsers/MarkdownRule"

export const emphasis: MarkdownRule = defaultRules.em
